"use strict";module.exports=(r=0,e=2,t=!0)=>Intl.NumberFormat("en-US",{style:t?"currency":"decimal",currency:"USD",minimumFractionDigits:e}).format(r);
//# sourceMappingURL=index.js.map
